import React from 'react';
import Button from '../../components/Button';
import DetailTitle from '../../components/DetailTitle';
import ImgMSG from '../../assets/images/detail/msg01.png';

const MSGScreen = () => {
  return (
    <div className='container'>
      <div className='detail-wrap row'>
        <DetailTitle title='MSG運營總後台' />
        <div className='detail-content'>
          <ul className='skills'>
            <li>Branding</li>
            <li>UI/UX</li>
            <li>React</li>
          </ul>
          <img src={ImgMSG} alt='thumbnail' />
        </div>
        <Button text='BACK' go='/works' />
      </div>
    </div>
  );
};
export default MSGScreen;
